<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">外部システム連携</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="column-list">
          <label class="list-input-title">対象</label>
          <div class="list-input-content element-column">
            <app-radio-label [label]="'営業カレンダー'" id="btn_BusinessCalendar" #btn_BusinessCalendar
              [subid]="'btn_BusinessCalendar'" [forcedEnabledMode]="''" [tabindex]="0" groupname="upload_List"
              [(ngModel)]="KYMW9400Model.uploadType" value="1">
            </app-radio-label>
            <app-radio-label label="利用予算人数" id="btn_UseBudgetNumber" #btn_UseBudgetNumber
              [subid]="'btn_UseBudgetNumber'" [forcedEnabledMode]="''" [tabindex]="0" groupname="upload_List"
              [(ngModel)]="KYMW9400Model.uploadType" value="2">
            </app-radio-label>
            <app-radio-label [label]="'按分比率'" id="btn_ProportionalDistributionRatio" #btn_ProportionalDistributionRatio
              [subid]="'btn_ProportionalDistributionRatio'" [forcedEnabledMode]="''" [tabindex]="0" groupname="upload_List"
              [(ngModel)]="KYMW9400Model.uploadType" value="3">
            </app-radio-label>
            <app-radio-label label="予算" id="btn_Budget" #btn_Budget
              [subid]="'btn_Budget'" [forcedEnabledMode]="''" [tabindex]="0" groupname="upload_List"
              [(ngModel)]="KYMW9400Model.uploadType" value="4">
            </app-radio-label>
          </div>

        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button  class="btn-primary" forcedEnabledMode="" id="btn_Upload" #btn_Upload
            [tabindex]="0" (click)="eventUpload_CLICKHandler()">取込</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button forcedEnabledMode="true" id="btn_Close" #btn_Close
            [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
